/**
 * Main App Component
 */

import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { AppProvider } from './context/AppContext';
import Sidebar, { SidebarRef } from './components/Sidebar';
import { TestAI } from './components/TestAI';
import './App.css';

type AppProps = {
  userName: string | null;
  setUserName?: (name: string | null) => void;
};

function App({ userName, setUserName }: AppProps) {
  const location = useLocation();
  const sidebarRef = useRef<SidebarRef>(null);

  // Render content based on current route
  const renderContent = () => {
    switch (location.pathname) {
      case '/test-ai':
        return <TestAI sidebarRef={sidebarRef} />;
      case '/dashboard':
        // TODO: Add Dashboard component
        return <div className="p-8">Dashboard content coming soon...</div>;
      case '/projects':
        // TODO: Add Projects component
        return <div className="p-8">Projects content coming soon...</div>;
      case '/settings':
        // TODO: Add Settings component
        return <div className="p-8">Settings content coming soon...</div>;
      default:
        return <TestAI sidebarRef={sidebarRef} />;
    }
  };

  return (
    <AppProvider>
      <div className="App flex h-screen">
        <Sidebar ref={sidebarRef} userName={userName} setUserName={setUserName} />
        
        <main className="App-main flex-1 overflow-auto lg:ml-0">
          <div className="container h-full mainWrapper">
            {renderContent()}
          </div>
        </main>
      </div>
    </AppProvider>
  );
}

export default App;
